import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Button, Modal } from "antd";
import { CloseOutlined, SaveOutlined, ExclamationCircleOutlined, MinusOutlined } from "@ant-design/icons";

import { DrawerNav, TabelaDados } from '..';
import { useStateValue } from '../../state';
import ManutencaoClientes from './manutencao';
import { drawerActions, listagemActions, manutencaoActions } from '../../actions';

export default function DrawerCliente({ editando, setEditando, adicionarCliente }) {

    const nameForm = "manutencaoVendedor"
    const [formCliente] = Form.useForm();
    const [{ ui, manutencao, listaSelectPaginado, listaTabelaDados }, dispatch] = useStateValue();
    const TIPO_PESSOA = { FISICA: 1, JURIDICA: 2, ESTRANGEIRO: 3 }
    const [carregando, setCarregando] = useState(false);

    function fecharDrawer() {
        formCliente.resetFields();
        setEditando(false);
        dispatch({ type: listagemActions.CHANGE, data: { ordem: '+pes_nome' } });
        dispatch({ type: drawerActions.CHANGE, data: { showDrawer: false } });
        //dispatch({ type: manutencaoActions.CHANGE, data: { dados: null } });
    }

    const onClose = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação e ignorar o que foi realizado até o momento?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            zIndex: 2001,
            onOk() {
                fecharDrawer();
            },
        });
    };

    return (
        <DrawerNav title="Cadastro Cliente"
            width="70%"
            closeIcon={<MinusOutlined />}
            footer={
                <div>
                    <Row align="middle" justify="end" gutter={[8, 0]}>
                        <Col>
                            <Button onClick={onClose} icon={<CloseOutlined />} size="large" htmlType="button">
                                Cancelar
                            </Button>
                        </Col>
                        <Col>
                            <Button onClick={() => formCliente.submit()} loading={carregando} icon={<SaveOutlined />} size="large" type="primary" htmlType="submit">
                                Salvar
                            </Button>
                        </Col>
                    </Row>
                </div>
            }>
            <ManutencaoClientes formulario={formCliente} nameForm={nameForm} carregando={setCarregando} aoSalvar={fecharDrawer} editando={editando} setEditando={setEditando} adicionarCliente={adicionarCliente}/>
        </DrawerNav>

    )
}